import { format } from 'date-fns';
import { Inventory } from '~/types/common';

import * as fp from 'lodash/fp';

export default function getDateInventory(inventory: Inventory, date: Date | null) {
  const dateString = date ? format(date, 'yyyyMMdd') : '';
  const currentInventory = fp.isNumber(inventory.current[dateString])
    ? inventory.current[dateString]
    : inventory.default;

  const reservedInventory = inventory.reserved[dateString] || 0;

  return currentInventory - reservedInventory;
}
